import type { RouteRecordRaw } from 'vue-router';

export const connectorRoutes: RouteRecordRaw[] = [
  {
    path: '/connectors/oauth/callback',
    name: 'connector-oauth-callback',
    component: () => import('@/pages/SettingsPage/ConnectorOAuthCallback.vue'),
  },
];
